/**
 * Simple Image Popup
 * - Shows after user has been on site for specified delay
 * - Stores cookie when closed to prevent reappearing for specified period
 */
class Popup {
  constructor(popupElement) {
    this.popup = popupElement;
    this.id = this.popup.id;
    this.delay = parseInt(this.popup.dataset.delay, 10) || 5000; // Default 5 seconds
    this.cookieExpiry = parseInt(this.popup.dataset.cookieExpiry, 10) || 30; // Default 30 days
    this.closeButton = this.popup.querySelector(".popup__close-text");
    this.overlay = this.popup.querySelector(".popup__overlay");

    this.cookieName = `popup-${this.popup.dataset.cookieName}-closed`;
    // this.cookieName = `popup-${this.id}-closed`;

    this.init();
  }

  init() {
    // Check if cookie exists
    if (this.getCookie(this.cookieName)) {
      return; // Don't show popup if cookie exists
    }

    // Set timeout to show popup after delay
    setTimeout(() => {
      this.show();
    }, this.delay);

    // Add event listeners
    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.close());
    }

    // Close on Escape key
    document.addEventListener("keyup", (event) => {
      if (event.key === "Escape" && this.popup.classList.contains("active")) {
        this.close();
      }
    });
  }

  show() {
    document.body.classList.add("overflow-hidden");
    this.popup.classList.add("active");
  }

  close() {
    document.body.classList.remove("overflow-hidden");
    this.popup.classList.remove("active");
    this.setCookie(this.cookieName, "true", this.cookieExpiry);
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  getCookie(name) {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return null;
  }
}

// Initialize all popups on the page
document.addEventListener("DOMContentLoaded", () => {
  const popups = document.querySelectorAll('[id^="popup-"]');
  popups.forEach((popup) => {
    new Popup(popup);
  });
});
